import axios from 'axios'
import store from '../store'
import { MessageBox,Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import { Const } from '@/consts'
import utils from '@/utils'
import Qs from 'qs'
import bus from '@/bus'

let requestQ = []
const device = 'wechat|' + navigator.userAgent

// 创建axios实例
const service = axios.create({

  // baseURL: process.env.BASE_API, // api的base_url
  // baseURL: 'https://www.dxzypx.com/', // api的base_url
  baseURL: '', // api的base_url
  timeout: 30000, // 请求超时时间
  // `transformRequest` allows changes to the request data before it is sent to the server
  // This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
  // The last function in the array must return a string or an instance of Buffer, ArrayBuffer,
  // FormData or Stream
  // You may modify the headers object.
  transformRequest: [
    function (data, headers) {
      headers[Const.H_DEVICE] = device
      headers[Const.H_AUTH] = utils.getUserToken()

      if (headers['Content-Type']) {
        return data
      }

      return Qs.stringify(data)
    }
  ]
})

// request 拦截器
/*service.interceptors.request.use((config) => {
  if (!config.headers.NLoading) {
    requestQ.push(1)
    Indicator.open()
  } else {
    delete config.headers.NLoading
  }

  return config
}, (error) => {
  // error
})*/

// respone 拦截器
service.interceptors.response.use(
  response => {
    if (!requestQ.pop() || !requestQ.length) {
      Indicator.close()
    }

    let resp = response.data
    resp.statusCode = resp.statusCode || '200'
    if (resp[Const.RESP_STATUS] == Const.STATUS_OK || resp["code"] == '0') {
      return resp
    } else if (resp[Const.RESP_STATUS] == Const.STATUS_EXPIRE||resp[Const.RESP_STATUS_CODE] == 'INVALID'||resp[Const.RESP_STATUS_CODE] == 'EXPIRED'||resp[Const.RESP_STATUS_CODE] == 'NOT_FOUND') {
      //"拦截信息："+",状态："+resp[Const.RESP_STATUS]+",状态码："+resp[Const.RESP_STATUS_CODE]+"用户状态失效")
      bus.$emit('loginExpired')
      return Promise.reject(resp)
    } else {
      return Promise.reject(resp)
    }
  },
  error => {
    //alert("网络超时或网络错误："+error)
    console.log(error)
    if (!requestQ.pop() || !requestQ.length) {
      Indicator.close()
    }
    let resp = error.response?error.response.data:error||{}
    // Toast( resp[Const.RESP_NOTOK_MESSAGE] || resp[Const.RESP_MESSAGE]  || '出错了 ...');
    if (resp[Const.RESP_STATUS] == Const.STATUS_EXPIRE||resp[Const.RESP_STATUS_CODE] == 'INVALID'||resp[Const.RESP_STATUS_CODE] == 'EXPIRED'||resp[Const.RESP_STATUS_CODE] == 'NOT_FOUND') {
      //alert("拦截错误："+",状态："+resp[Const.RESP_STATUS]+",状态码："+resp[Const.RESP_STATUS_CODE]+"错误信息,"+error)
      bus.$emit('loginExpired')
    }
    return Promise.reject(resp)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js



// WEBPACK FOOTER //
// ./src/utils/request.js